// A simple function that's easy to mock with jest.
// Like a lite dependency injection without a class!
export function getLocalStorage() {
  return localStorage;
}
